<template>
  <div class="snake-wrapper">
    <el-tooltip placement="top" v-for="index in steps" :key="index-1" :content="labels[index-1]" :disabled="!labels[index-1]">
      <div class="snake-step" style="height: 10px;" :class="{['bg-'+color]: index >= start && index <= end}">&nbsp;</div>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: 'base-snake',
  props: {
    steps: {
      type: Number,
      default: 5,
    },
    color: {
      type: String,
      default: 'info',
    },
    start: {
      type: Number,
      default: 0,
    },
    end: {
      type: Number,
      default: 0,
    },
    labels: {
      type: [Array, Object],
      default: () => [],
    }
  },
}
</script>

<style lang="scss" scoped>
.snake-wrapper {
  width: 100%;
  height: 10px;
  border-radius: 30px;
  overflow: hidden;
  margin: 6px;
  display: flex;

  .snake-step {
    background-color: #8080804f;
    flex-grow: 1;
    height: 10px;
    transition: opacity 100ms linear;

    &:nth-child(n+2) {
      margin-left: 1px;
    }

    &:hover {
      opacity: 0.5;
    }
  }
}
</style>